module.exports = __webpack_public_path__ + "img/roulette.f403aa21.jpg";